const defaultFontStack = () => {
  return {
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      `"Segoe UI"`,
      `"Roboto"`,
      `"Oxygen"`,
      `"Ubuntu"`,
      `"Cantarell"`,
      `"Fira Sans"`,
      `"Droid Sans"`,
      `"Helvetica Neue"`,
      "sans-serif",
    ].join(", "),
  };
};

const decorativeFontStack = () => {
  return {
    fontFamily: [
      `"Gill Sans"`,
      `"Trebuchet MS"`,
      "Calibri",
      "Arial",
      "sans-serif",
    ].join(", "),
  };
};

export { defaultFontStack, decorativeFontStack };
